import HeroSection from "@/Components/Landing/Hero";
import Navbar from "@/Components/Landing/Navbar";
import VendorFeatures from "@/Components/Landing/VendorFeatures";
import Vision from "@/Components/Landing/Vision";
import Footer from "@/Components/Landing/Footer";
import FoodWasteCounter from "@/Components/Landing/FoodWasteCounter";
import MobileApp from "@/Components/Landing/MobileApp";
import FoodWaste from "@/Components/Landing/FoodWaste";
import EnvSection from "@/Components/Landing/Environment";
import SocialImpact from "@/Components/Landing/Social";
import EconomicImpact from "@/Components/Landing/Economic";
import MysteryBag from "@/Components/Landing/MysteryBag";


function App() {
  return (
    <div className="App">
      <Navbar />
      <HeroSection />
      <Vision />
      <FoodWasteCounter />
      <MobileApp />
      <FoodWaste />
      <VendorFeatures />
      <MysteryBag />

      <EnvSection />
      <SocialImpact />

      <EconomicImpact />

      <Footer />
    </div>
  );
}

export default App;
